<template>
  <div>
    <company-form-links :company_id="payload.data.resource_id"></company-form-links>
    <a @click="editAccountingCompany" class="button is-info">Edit Accounting Company</a>
    <div v-if="form" style="text-align: right; margin-top: 20px;" dir="rtl">
      <div>
        <p class="bold">name</p>
        <input
          v-model="form.data.company.fields.name.value"
          class="outlined full_width"
          placeholder="name"
        />
      </div>
      <div>
        <p class="bold">first_name</p>
        <input
          v-model="form.data.company.fields.first_name.value"
          class="outlined full_width"
          placeholder="first_name"
        />
      </div>
      <div>
        <p class="bold">last_name</p>
        <input
          v-model="form.data.company.fields.last_name.value"
          class="outlined full_width"
          placeholder="last_name"
        />
      </div>
      <div>
        <p class="bold">phone_number</p>
        <input
          v-model="form.data.company.fields.phone_number.value"
          class="outlined full_width"
          placeholder="phone_number"
        />
      </div>
      <div>
        <p class="bold">email</p>
        <input
          v-model="form.data.company.fields.email.value"
          class="outlined full_width"
          placeholder="email"
        />
      </div>
      <div>
        <p class="bold">status</p>
        <select v-model="form.data.company.fields.status.value">
          <option value="active">active</option>
          <option value="blocked">blocked</option>
          <option value="pending">pending</option>
          <option value="test">test</option>
        </select>
      </div>
      <div>
        <p class="bold">message</p>
        <input
          v-model="form.data.company.fields.message.value"
          class="outlined full_width"
          placeholder="message"
        />
      </div>
      <div>
        <p class="bold">owner</p>
        <input
          v-model="form.data.company.fields.owner.value"
          class="outlined full_width"
          placeholder="owner"
        />
      </div>
      <div>
        <p class="bold">priority warning</p>
        <input
          v-model="form.data.company.fields.priority_warning.value"
          class="outlined full_width"
          placeholder="priority warning"
        />
      </div>
      <div>
        <p class="bold">מצב שליחת קורות חיים דפולטיבי</p>
        <select v-model="form.data.company.fields.default_cv_sending_mode.value">
          <option value="normal">רגיל (Normal)</option>
          <option value="lite">לייט (Lite)</option>
          <option value="super_lite">סופר לייט (Super Lite)</option>
        </select>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import CompanyFormLinks from '@/components/CompanyFormLinks'
export default {
  props: ['payload'],
  name: 'admin-company-form',
  data () {
    return {
      is_loading: false,
      form: undefined,
      compnay: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getUser(this.payload.data.id).then((response) => {
        this.setForm(response)
        this.company = response.resource.company
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        company: {
          fields: {
            name: {
              value: form_data.resource.company.name,
              has_error: false,
              validations: []
            },
            first_name: {
              value: form_data.first_name,
              has_error: false,
              validations: []
            },
            last_name: {
              value: form_data.last_name,
              has_error: false,
              validations: []
            },
            phone_number: {
              value: form_data.phone_number,
              has_error: false,
              validations: []
            },
            email: {
              value: form_data.email,
              has_error: false,
              validations: []
            },
            status: {
              value: form_data.status,
              has_error: false,
              validations: []
            },
            message: {
              value: form_data.message,
              has_error: false,
              validations: []
            },
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            priority_warning: {
              value: form_data.resource.company.priority_warning,
              has_error: false,
              validations: []
            },
            default_cv_sending_mode: {
              value: form_data.resource.company.default_cv_sending_mode || 'normal',
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/users/' + form_data.id,
            data: { resource_type: 'Company' },
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    editAccountingCompany () {
      this.create({
        designator: 'accounting-company-form-modal',
        component_name: 'AccountingCompanyForm',
        company: this.company,
        is_modal: true,
        modal_title: 'Accounting Company'
      })
    },
    ...mapMutations('modals', ['create', 'remove'])
  },
  components: {
    CompanyFormLinks
  }
}
</script>
